import script from "./LabOSView.vue?vue&type=script&setup=true&lang=ts"
export * from "./LabOSView.vue?vue&type=script&setup=true&lang=ts"

import "./LabOSView.vue?vue&type=style&index=0&id=5ec51b42&lang=css"
import "./LabOSView.vue?vue&type=style&index=1&id=5ec51b42&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ec51b42"]])

export default __exports__